import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  name: string,
  type: string,
  clientId: string,
  clientSecret: string,
  isClientSecretEdited: boolean,
  oktahost: string,
  tenantId: string,
  enabled: boolean,
  managed: boolean,
  groupMembership: string
} = {
  id: '',
  name: '',
  type: 'azure',
  clientId: '',
  clientSecret: '',
  isClientSecretEdited: false,
  oktahost: '',
  tenantId: '',
  enabled: true,
  managed: false,
  groupMembership: ''
};

class OpenIDConfig extends Immutable.Record(Content) {
  static fromJS (json: object): OpenIDConfig {
    return ClassFactory.createFromJson(json, OpenIDConfig);
  }

  isOkta (): boolean {
    return this.type === 'okta';
  }

  isNew (): boolean {
    return this.id === '';
  }
}

export default OpenIDConfig;
